import * as React from 'react';
import * as Sentry from '@sentry/browser';
import { useState, useEffect } from 'react';
import { myAreaStatsWatchtime } from '../../../../Utilities/api';
import Spinner from '../../Spinner';
import { useI18n } from '../../../../Translation';
import ProfileStatsInfoToolTip from './ProfileStatsInfoToolTip';
const ProfileStatsTileWatchTime = ({ label }) => {
    const i18n = useI18n();
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await myAreaStatsWatchtime();
                setData(result);
            }
            catch (error) {
                Sentry.captureException(error);
                setHasError(true);
            }
            finally {
                setIsLoading(false);
            }
        };
        fetchData();
    }, []);
    return <div className="relative rounded-lg bg-white px-4 py-5 shadow-lg sm:p-6">
        <ProfileStatsInfoToolTip content={'Anzahl der Minuten, die an Videos insgesamt geguckt wurden'}/>

        <div className="overflow-hidden">
            <dt className="truncate text-sm font-medium text-gray-500">{label}</dt>
            {isLoading ? (<Spinner />) : (<>
                    {hasError ? (<i className="mt-1">{i18n['profile.healthScore.errorWhileLoading']}</i>) : data ? (<dd className="mt-1 text-3xl font-semibold tracking-tight text-gray-900">{data.in_minutes_rounded}</dd>) : (<></>)}
                </>)}
        </div>
    </div>;
};
ProfileStatsTileWatchTime.displayName = 'ProfileStatsTileWatchTime';
export default ProfileStatsTileWatchTime;
